import { Component, inject, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MenuModule } from 'primeng/menu';
import { CreateDepartmentComponent } from './create-department/create-department.component';
import { DeleteDepartmentComponent } from './delete-department/delete-department.component';


@Component({
  selector: 'app-department-section',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ButtonModule,
    ProgressSpinnerModule,
    MenuModule,
    CreateDepartmentComponent,
    DeleteDepartmentComponent,

  ],
  templateUrl: './department-section.component.html',
})
export class DepartmentComponent implements OnInit {
  @Input() orgId!: string;
  departments: any[] = [];
  totalRecords: number = 0;
  rows = 10;
  loading: boolean = false;

  displayAddModal = false;
  addForm: FormGroup;

  selectedDepartments: any[] = [];
  actionItems: MenuItem[] = [];
  searchText: string = '';
  searchAttribute: string = 'name';
  departmentDataToEdit: any = null;
  showEditDepartment: boolean = false;
  showDeleteDepartment: boolean = false;
  campuses: any[] = [];
  users: any[] = [];

  campusLoading: boolean = false;
  userLoading: boolean = false;

  setDepartmentData(data: any) {
    this.departmentDataToEdit = data;
  }

  departmentActionItem: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Department',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.showEditDepartment = true;
          }
        },
        {
          label: 'Delete Department',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.showDeleteDepartment = true;
          }
        }
      ]
    }
  ];

  constructor(
    private orgService: OrganizationService,
    private fb: FormBuilder
  ) {
    this.addForm = this.fb.group({
      organization_id: [this.orgId, Validators.required],
      campus_id: ['', Validators.required],
      name: ['', Validators.required],
      code: ['', Validators.required],
      head_of_department: [''],
      description: [''],
      contact_number: [''],
      email: [''],
      status: ['Active'],
      is_public: [true]
    });
  }

  ngOnInit(): void {
    this.setupActionItems();
    this.getAllCampus()
    this.getAllUsers()
  }

  getAllUsers() {
    this.userLoading = true;

    const payload = {
      "page": 0,
      "limit": 100,
      "where": {
        "organization_id": this.orgId,
      }
    }

    this.orgService.getAllUsers(payload).subscribe({
      next: (data) => {
        this.users = data?.rows  // Assuming the response has 'rows' property
        this.userLoading = false;
      },
      error: (err) => {
        console.error('❌ API Error:', err); // Log the error
        this.userLoading = false;
      }
    });
  }

  getAllCampus() {
    this.campusLoading = true;

    const payload = {
      organization_id: this.orgId
    };
    this.orgService.getAllCampus(payload).subscribe({
      next: (data) => {
        this.campuses = data || []  // Assuming the response has 'rows' property
        this.campusLoading = false;
      },
      error: (err) => {
        console.error('❌ API Error:', err); // Log the error
        this.campusLoading = false;
      }
    });
  }


  setupActionItems() {
    this.actionItems = [
      {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => {
          const selected = this.selectedDepartments[0];
          this.addForm.patchValue(selected);
          this.displayAddModal = true;
        }
      },
      {
        label: 'Delete',
        icon: 'pi pi-trash',
        command: () => {
          const id = this.selectedDepartments[0]?.dept_id;
          if (id) {
            this.orgService.deleteDepartment(id).subscribe(() => {
              this.loadDepartments({ first: 0, rows: this.rows });
            });
          }
        }
      }
    ];
  }

  openAddModal() {
    this.addForm.reset();
    this.addForm.patchValue({ organization_id: this.orgId });
    this.displayAddModal = true;
  }

  closeAddModal() {
    this.displayAddModal = false;
    this.addForm.reset();
  }

  saveDepartment() {
    if (this.addForm.valid) {
      this.orgService.createDepartment(this.addForm.value).subscribe(() => {
        this.loadDepartments({ first: 0, rows: this.rows });
        this.closeAddModal();
      });
    }
  }

  openMenu(event: MouseEvent, department: any) {
    this.selectedDepartments = [department];
    const menu = document.querySelector('p-menu') as any;
    menu?.toggle(event);
  }

  loadDepartments(event: any, searchValue?: string, searchAttribute?: string): void {
    this.loading = true;
    const payload = {
      organization_id: this.orgId
    };

    this.orgService.getAllDepartment(payload).subscribe({
      next: (data) => {
        this.departments = data;
        this.loading = false;
      },
      error: (err) => {
        console.error('❌ API Error:', err);
        this.loading = false;
      }
    });
  }

  reload() {
    this.loadDepartments({ first: 0, rows: this.rows });
  }

  handleSearch() {
    this.loadDepartments({ first: 0, rows: this.rows }, this.searchText, this.searchAttribute);
  }
}
